var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.footerClass},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-left":"5px"}},[_vm._v("Copyright © 2020 Parkonomy Ltd. All Rights Reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }